/**
 * 権限用Enum
 */
export const Roles = {
  USER: { id: 1, name: "user", label: "一般ユーザー" },
  ADMIN: { id: 2, name: "admin", label: "管理者" },
} as const;

export type RoleId = typeof Roles[keyof typeof Roles]["id"];